import { Skeleton } from '@heroui/react';
import React from 'react'

const VaoCardLoader = () => {
  return (
    <>
      <div className="border border-[#C2C2C2] rounded-xl overflow-hidden h-fit">
        <div className="bg-black h-5 flex items-center justify-center px-2">
          <Skeleton className="w-full h-3 rounded-md dark"></Skeleton>
        </div>
        <div className="p-2.5 flex flex-col gap-5 h-[calc(100%-1.25rem)]">
          <div className="flex items-center justify-between">
            <Skeleton className="w-16 h-6 rounded-md"></Skeleton>
            <Skeleton className="w-20 h-6 rounded-md"></Skeleton>
          </div>
          <Skeleton className="w-full h-4 rounded-md"></Skeleton>
          <Skeleton className="w-full h-6 rounded-md"></Skeleton>
        </div>
      </div>
    </>
  )
}

export default VaoCardLoader;
